import { authOptions } from '@/app/api/auth/[...nextauth]/route';
import { deleteCookie, setCookie } from 'cookies-next';
import { getServerSession } from 'next-auth';
import { signIn, signOut } from 'next-auth/react';
import { redirect } from 'next/navigation';
import { decodeJwt } from '../global';
import { toast } from 'sonner';
import { event_user_auth } from '../gtm';

// session and handshake in server side
// const session = await getServerSessionData();
// const handshake = (await cookies()).get('handshake')?.value;

// session and handshake in client side
// const { data: session, status } = useSession();
// const handshake = getCookie('handshake');

export const getServerSessionData = async ({
  allowRedirection = true,
  redirectionLink = '/',
} = {}) => {
  const session = await getServerSession(authOptions);

  if (!session && allowRedirection) {
    redirect(redirectionLink);
  }

  return session;
};

export const signOutHandler = () => {
  localStorage.removeItem('cart');
  localStorage.removeItem('checkout');
  deleteCookie('quote');
  deleteCookie('mage');

  signOut({ callbackUrl: '/' });
};

export const signInHandler = async ({
  response,
  rememberMe,
  locale,
  clearCheckout,
  setActiveShippingMethod,
  setAuth,
  getFilterObj,
  push,
  loginType,
}) => {
  const token = response?.data?.token;

  const decodedToken = decodeJwt(token, false);
  const expires = new Date(decodedToken.exp * 1000);

  setCookie('mage', token, { expires });

  const user = {
    id: response?.data?.user?.id,
    store_id: response?.data?.user?.store_id,
    email: response?.data?.user?.email,
    firstname: response?.data?.user?.firstname,
    lastname: response?.data?.user?.lastname,
    mobilenumber: response?.data?.user?.custom_attributes?.find(
      (attr) => attr.attribute_code === 'mobilenumber'
    )?.value,
    rememberMe,
    created_at: response?.data?.user?.created_at,
  };

  const res = await signIn('credentials', {
    token,
    user: JSON.stringify(user),
    callbackUrl: '/',
    redirect: false,
  });

  if (!res.ok && res.status !== 200) {
    toast.error(
      locale === 'en'
        ? 'sign in failed, please try again'
        : 'خطأ فى تسجيل الدخول, يرجى المحاولة مرة أخرى'
    );
  } else {
    clearCheckout();
    setActiveShippingMethod(null);

    if (user) {
      event_user_auth(user, 'user_login', loginType);
      console.log('user is printing', user);
      toast.success(
        locale === 'en' ? 'You logged in successfully' : 'تم تسجيل الدخول بنجاح'
      );
      setAuth(false);
      if (getFilterObj?.url && getFilterObj?.url.startsWith('/user')) {
        push(getFilterObj?.url);
      }
    }
  }
};
